var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight816(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.643351 1.07505C0.967787 0.708299 1.4938 0.708299 1.81824 1.07505L7.3567 7.33592C7.68113 7.70268 7.68113 8.2973 7.3567 8.66405L1.81824 14.9249C1.4938 15.2917 0.967787 15.2917 0.643351 14.9249C0.318916 14.5582 0.318916 13.9635 0.643351 13.5968L5.59437 7.99999L0.643351 2.40318C0.318916 2.03643 0.318916 1.44181 0.643351 1.07505Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight816);
export default __webpack_public_path__ + "static/media/arrow-right-8-16.e263d26007e85d12451688f7bde03601.svg";
export { ForwardRef as ReactComponent };